import { withCurrentParams } from 'actions/utils';
import { BROADCAST_UPDATE_LIVE_RECORDING } from 'actions/Types';
import { BROADCAST_RECORDING_UPDATE } from 'store/eventConstants';

/**
 * Update live recording
 *
 * @param {*} payload Updated recording payload
 * @param {*} recording Recording to update
 */
export default (payload, recording) => {
  return withCurrentParams(
    (dispatch, { teamId, eventId, broadcastId }, getState, socket) => {
      const {
        meeting: { attendeeResponse }
      } = getState();
      const recordingId = recording._id;
      const action = {
        type: BROADCAST_UPDATE_LIVE_RECORDING,
        request: async apiClient => {
          const resp = await apiClient.broadcast.updateRecording(
            teamId,
            eventId,
            broadcastId,
            recordingId,
            payload
          );
          // notify other directors
          socket.emit(BROADCAST_RECORDING_UPDATE, {
            broadcastId,
            notifyingDirector:
              attendeeResponse && attendeeResponse.Attendee.AttendeeId
          });
          return resp;
        }
      };
      dispatch(action);
    }
  );
};
